export default "https://cdn-static.gokick.com/assets/eeaee1442152ca0221916151b947444cbee5198d/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";